const base64ToBlob = (base64) => {
  const byteCharacters = atob(base64.split(",")[1]);

  // eslint-disable-next-line prefer-destructuring
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: mimeString });
};

export default base64ToBlob;
